import type { ExternalTableSchema } from '@packages/table-builder';

export const companyMappingTable: ExternalTableSchema = {
  metadata: {
    title: 'Companies',
    entity: 'AllowedCompanyMapping',
    description: 'List of companies for mapping.',
  },

  dataSource: {
    endpoint: '/api/customer/api/customer/customer-success/allowed-company-mappings',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'sourceCompanyName',
      header: 'Source Company Name',
      type: 'text',
      width: 250,
      align: 'left',
    },
    {
      field: 'destinationCompanyName',
      header: 'Destination Company Name',
      type: 'text',
      width: 250,
      align: 'left',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_COMPANY_MAPPING', label: 'View' },
      { id: 'EDIT_COMPANY_MAPPING', label: 'Edit' },
      { id: 'DELETE_COMPANY_MAPPING', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_COMPANY_MAPPING',
        label: 'Add Mapping',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Company Mapping',
      resizable: true,
      reorderable: true,
    },
  },
};
